import type PermissionsRepository from "@/core/administration/repositories/PermissionsRepository";
import type { PermissionsResponse } from "@/core/administration/repositories/PermissionsRepository";
import type { ApiPermissionItem } from "@/core/administration/entities/PermissionCatalog";
import type { RepositoryResult } from "@/core/shared/types/RepositoryResult";
import { HttpClient } from "../../http/HttpClient";
import { ApiResponse } from "../../api/types/ApiResponse";
import { executeRequest } from "../../http/services/executeRequest/executeRequest";
import PermissionCatalogMapper from "@/core/administration/mappers/PermissionCatalogMapper";
import { getPermissionsUrl } from "../../api/permissionsBackendEndpoints/permissionsBackendEndpoints";

export default class PermissionsRepositoryBackend implements PermissionsRepository {
  constructor(private readonly httpClient: HttpClient) {}

  getPermissions(
    offset: number,
    rows: number,
  ): Promise<RepositoryResult<PermissionsResponse>> {
    return executeRequest(
      () =>
        this.httpClient.get<
          ApiResponse<{ items: ApiPermissionItem[]; totalElements: number }>
        >({
          url: getPermissionsUrl(offset, rows),
          withAuth: true,
        }),
      (data) => {
        const rawTotalElements = data.totalElements;
        const totalElements =
          typeof rawTotalElements === "number"
            ? rawTotalElements
            : typeof rawTotalElements === "string"
              ? parseInt(rawTotalElements, 10) || 0
              : 0;

        const items = PermissionCatalogMapper.toDomainItems(data.items || []);

        return {
          items,
          totalElements,
        };
      },
    );
  }
}
